import { Reveal } from "@components/ui";

/* ─── Data ─── */

const steps = [
  {
    num: "01",
    title: "Meter Reading",
    items: [
      "Smart meters are read remotely",
      "Mechanical meters are read monthly by GASIS or submitted by customer",
      "Estimated readings may be used temporarily if meter is inaccessible or damaged",
    ],
  },
  {
    num: "02",
    title: "Consumption Calculation",
    items: [
      "Actual Consumption (m³) × AED 35 per m³",
      "Billing/Admin Fee: AED 20 per invoice",
      "Smart Meter Connection Fee: AED 25 (one-time)",
    ],
  },
  {
    num: "03",
    title: "Invoice Generated",
    items: [
      "Billing period & meter readings",
      "Consumption in m³ or Kg",
      "Tariff rate & applicable charges",
      "VAT (5%) and total payable",
    ],
  },
];

/* ─── Component ─── */

export function BillingStepsSection() {
  return (
    <section className="w-full bg-white py-12 md:py-16 lg:py-[120px] px-5 md:px-10 lg:px-[180px]">
      <div className="w-full max-w-[1368px] mx-auto">
        {/* Header */}
        <Reveal direction="up">
          <div className="flex flex-col items-center gap-3 md:gap-4 mb-10 md:mb-12">
            <h2 className="text-center text-[28px] md:text-[44px] lg:text-[60px] tracking-[-0.04em] font-semibold text-[#122d63] leading-[1.1]">
              How Billing Works
            </h2>
            <p className="text-center text-[14px] md:text-[18px] lg:text-[28px] tracking-[-0.04em] text-[#62636c] max-w-[966px]">
              Clear, simple steps from meter reading to payment
            </p>
          </div>
        </Reveal>

        {/* Steps grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {steps.map((step, index) => (
            <Reveal key={step.num} direction="up" delay={index * 100}>
              <div className="group h-full rounded-[16px] md:rounded-[24px] border border-[#62636c33] bg-white p-5 md:p-6 flex flex-col gap-4 md:gap-5 hover:border-[#e8e9ed] hover:shadow-[0_4px_20px_rgba(0,0,0,0.08)] transition-all duration-300">
                {/* Number badge */}
                <div className="w-12 h-12 md:w-14 md:h-14 rounded-[12px] md:rounded-[16px] bg-[#f24d2b] flex items-center justify-center">
                  <span className="text-[18px] md:text-[24px] font-semibold text-white font-albert-sans">
                    {step.num}
                  </span>
                </div>

                {/* Title */}
                <h3 className="text-[18px] md:text-[22px] lg:text-[24px] tracking-[-0.04em] font-semibold text-[#1c1c1c] font-albert-sans">
                  {step.title}
                </h3>

                {/* List */}
                <div className="flex flex-col gap-2.5">
                  {step.items.map((item, i) => (
                    <div key={i} className="flex items-start gap-2.5">
                      <div className="w-2 h-2 rounded-full bg-[#f24d2b] mt-2 shrink-0" />
                      <span className="text-[14px] md:text-[16px] tracking-[-0.04em] leading-[1.5] text-[rgba(10,14,46,0.75)] font-albert-sans">
                        {item}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
